import { tsValidateArray, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
export const Validator_TagGroup = {
    key: tsValidateString(),
    value: tsValidateArray(tsValidateString()),
};
const Validator_ModifiableProps = {
    label: tsValidateString(),
    tagGroups: tsValidateArray(Validator_TagGroup),
};
const Validator_GeneratedProps = {
    __tagIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_MacroTag = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'macro-tag',
    entityName: 'MacroTag',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'macro-tag'
    },
    backend: {
        name: 'macro-tag'
    },
    dependencies: {
        __tagIds: {
            dbKey: 'tags',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map